import { AlertCircle } from 'lucide-react';
import { SectionHeaderAction, CustomizationFieldRow } from './CustomizationFieldRow';

export const CustomizationGuidedPanel = ({
  section,
  values,
  onValueChange,
  formatCurrency,
  missingRequired = [],
  showDelete = false,
  onDeleteField,
  onAddCustomField,
  showAddCustomField = false,
}) => {
  if (!section) {
    return (
      <div className="rounded-2xl border border-dashed border-slate-300 p-8 text-center text-slate-500" data-testid="customization-guided-empty-state">
        No sections available.
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="customization-guided-panel">
      <div className="rounded-2xl border border-slate-200 bg-white p-4">
        <div className="mb-1 flex items-center justify-between gap-2">
          <h3 className="text-lg font-semibold text-slate-900" data-testid="customization-guided-section-title">
            {section.name}
          </h3>
          {showAddCustomField && (
            <SectionHeaderAction
              onClick={() => onAddCustomField?.(section.category_id)}
              testId={`customization-add-custom-field-button-${section.category_id}`}
            />
          )}
        </div>
        <p className="text-xs text-slate-500" data-testid="customization-guided-section-meta">
          {section.visibleOptions?.length || 0} visible fields
        </p>
      </div>

      {missingRequired.length > 0 && (
        <div
          className="rounded-xl border border-rose-200 bg-rose-50 p-3"
          data-testid="customization-guided-required-alert"
        >
          <div className="mb-1 flex items-center gap-2 text-rose-700">
            <AlertCircle className="h-4 w-4" />
            <span className="text-sm font-semibold">Complete required fields to continue</span>
          </div>
          <p className="text-xs text-rose-700" data-testid="customization-guided-required-alert-list">
            {missingRequired.map((option) => option.name).join(', ')}
          </p>
        </div>
      )}

      <div className="grid gap-3" data-testid="customization-guided-field-list">
        {(section.visibleOptions || []).map((option) => (
          <CustomizationFieldRow
            key={option.option_id}
            sectionId={section.category_id}
            option={option}
            value={values?.[option.option_id]}
            onValueChange={onValueChange}
            formatCurrency={formatCurrency}
            showDelete={showDelete}
            showCustomBadge={showDelete}
            onDelete={onDeleteField}
          />
        ))}
      </div>
    </div>
  );
};
